import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import ModalPadraoForm from './ModalPadraoForm';
import VendaItemForm from './VendaItemForm';
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;


export default class CondicionalForm extends Component {
  state = {
    registro: {
      venc_idf: 0,
      venc_numero: '',
      venc_dt_venda: moment().format('DD/MM/YYYY'),
      venc_obs: '',
      venc_qtde_itens: 0,
      venc_vlr_itens: 0,
      venc_vlr_acres: 0,
      venc_vlr_desc: 0,
      venc_vlr_total: 0,
      venc_pessoa: { key: '0' },
      venc_usuario: { key: '0' },
    },
    modalProdutoVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,
    visualizar: false,

    activeKey: "dados",

    listaProdutos: [],
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.dados,
        venc_pessoa: this.props.registroSelecionado.dados.venc_pessoa,
        venc_usuario: this.props.registroSelecionado.dados.venc_usuario,
        listaProdutos: this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : [],
        visualizar: this.props.registroSelecionado.dados.visualizar,
        editando: false,
        activeKey: "dados",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaProdutos ? this.props.registroSelecionado.listaProdutos : []);
      });

      if (this.props.registroSelecionado.dados.venc_idf) {
        this.setState({
          editando: true,
          activeKey: "dados",
        });
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  onOK = () => {
    if ((!this.state.registro.venc_dt_venda) || (!moment(this.state.registro.venc_dt_venda, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }
    if ((!this.state.registro.venc_pessoa) || (this.state.registro.venc_pessoa.key === '0') || (this.state.registro.venc_pessoa.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Cliente', });
      return;
    }
    if ((!this.state.registro.venc_usuario) || (this.state.registro.venc_usuario.key === '0') || (this.state.registro.venc_usuario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor', });
      return;
    }
    if ((!this.state.listaProdutos) || (this.state.listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum produto na Venda' });
      return;
    }

    const registro = {
      venc_idf: this.state.registro.venc_idf,
      venc_dt_venda: moment(this.state.registro.venc_dt_venda, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      venc_numero: this.state.registro.venc_numero ? this.state.registro.venc_numero : '0',
      venc_pessoa: this.state.venc_pessoa.key,
      // pes_nome: this.state.venc_pessoa.label,
      venc_usuario: this.state.venc_usuario.key,
      venc_vlr_itens: this.state.registro.venc_vlr_itens,
      venc_vlr_desc: this.state.registro.venc_vlr_desc,
      venc_vlr_acres: this.state.registro.venc_vlr_acres,
      venc_vlr_total: this.state.registro.venc_vlr_total,
      venc_obs: this.state.registro.venc_obs,

      listaProdutos: this.state.listaProdutos,
    };


    this.props.onSalvarClick(registro);
  };

  calculoTotalPedido = (listaProdutos) => {
    const { registro } = this.state;
    let qtdeItens = 0;
    let vlrItens = 0;
    let vlrDesc = 0;
    let vlrAcres = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      qtdeItens = qtdeItens + parseFloat(listaProdutos[x].mi_qtde);
      vlrItens = vlrItens + (parseFloat(listaProdutos[x].mi_qtde) * parseFloat(listaProdutos[x].mi_vlr_unit));
      vlrDesc = vlrDesc + parseFloat(listaProdutos[x].mi_vlr_desc);
      vlrAcres = vlrAcres + parseFloat(listaProdutos[x].mi_vlr_acres);
      vlrTotal = vlrTotal + parseFloat(listaProdutos[x].mi_vlr_total);
    };

    qtdeItens = parseFloat(qtdeItens);
    vlrItens = parseFloat(vlrItens.toFixed(2));
    vlrDesc = parseFloat(vlrDesc.toFixed(2));
    vlrAcres = parseFloat(vlrAcres.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.venc_qtde_itens = qtdeItens;
    registro.venc_vlr_itens = vlrItens;
    registro.venc_vlr_desc = vlrDesc;
    registro.venc_vlr_acres = vlrAcres;
    registro.venc_vlr_total = vlrTotal;

    this.setState({
      registro,
    });
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['venc_pessoa'] = event.venc_pessoa;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['venc_usuario'] = event.venc_usuario;
    this.setState(event);
  }

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['venc_dt_venda'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ venc_dt_venda: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }



  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onFecharModalProdutoClick = () => {
    this.setState({
      modalProdutoVisible: false,
    });
  }

  onSalvarProdutoClick = (listaProdutos) => {
    this.setState({
      modalProdutoVisible: false,
      listaProdutos,
    },
      this.calculoTotalPedido(listaProdutos)
    );
  }

  onNovoProduto = (event) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: false,
        tipoTela: 'CON',
        registro: {
          mi_seq: 0,
          mi_item: { key: '0' },
          prod_codigo: '',
          prod_descricao: '',
          prod_cod_barras: '',
          mi_qtde: 1,
          mi_vlr_unit: 0,
          mi_vlr_venda: 0,
          mi_vlr_venda_min: 0,
          mi_perc_desc: 0,
          mi_vlr_desc: 0,
          mi_vlr_acres: 0,
          mi_vlr_total: 0,
          mi_calc_estoque: 1,
          tipoItem: 'P',
        }
      }
    });
  }

  onEditarProdutosClick = (reg) => {
    this.setState({
      modalProdutoVisible: true,
      produtoSelecionado: {
        listaProdutos: this.state.listaProdutos,
        editando: true,
        tipoTela: 'CON',
        registro: {
          mi_item: {
            key: String(reg.mi_item) + '_' + String(reg.mi_item_tamanho) + '_' + String(reg.mi_item_cor),
            label: (reg.prod_grade ? (reg.prod_descricao + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.prod_descricao) + ' [' + reg.prod_codigo + ']' + (reg.prod_cod_barras !== '' ? ' [' + reg.prod_cod_barras + ']' : ''),
            prod_grade: reg.prod_grade,
            prod_cod_barras: reg.prod_cod_barras,
            pest_item: reg.mi_item,
            pest_tamanho: reg.mi_item_tamanho,
            pest_cor: reg.mi_item_cor,
            ptam_descricao: reg.ptam_descricao,
            pcor_descricao: reg.pcor_descricao,
          },
          mi_seq: reg.mi_seq,
          prod_codigo: reg.prod_codigo,
          prod_descricao: reg.prod_descricao,
          prod_cod_barras: reg.prod_cod_barras,
          mi_qtde: reg.mi_qtde,
          mi_vlr_unit: reg.mi_vlr_unit,
          mi_vlr_venda: reg.mi_vlr_venda ? reg.mi_vlr_venda : 0,
          mi_vlr_venda_min: reg.mi_vlr_venda_min ? reg.mi_vlr_venda_min : 0,
          mi_perc_desc: reg.mi_perc_desc,
          mi_vlr_desc: reg.mi_vlr_desc,
          mi_vlr_total: reg.mi_vlr_total,
          mi_calc_estoque: reg.mi_calc_estoque,
          tipoItem: 'P',
        }
      }
    });
  }

  onExcluirProdutosClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaProdutos = [...this.state.listaProdutos];
        const index = listaProdutos.findIndex(registro => registro.prod_idf + '_' + registro.mi_item_tamanho + '_' + registro.mi_item_cor === reg.prod_idf + '_' + reg.mi_item_tamanho + '_' + reg.mi_item_cor);
        listaProdutos.splice(index, 1);
        this.setState({
          listaProdutos,
        },
          this.calculoTotalPedido(listaProdutos)
        );
      }
    })
  }



  renderValor = (venc_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(venc_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };


  renderAcoesProdutos = (registro) => {
    if (registro.mi_calc_estoque) {
      return (
        <ButtonGroup size="small">
          <Tooltip title="Editar">
            <Button type="primary" onClick={() => this.onEditarProdutosClick(registro)} icon="edit" />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button type="danger" onClick={() => this.onExcluirProdutosClick(registro)} icon="delete" />
          </Tooltip>
        </ButtonGroup>
      );
    } else {
      return
    }
  };





  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;

    const { carregandoForm, listaProdutos, produtoSelecionado, modalProdutoVisible, modalListaVisible } = this.state;

    const { venc_idf, venc_numero, venc_dt_venda, venc_pessoa, venc_obs,
      venc_qtde_itens, venc_vlr_total, venc_usuario } = this.state.registro;

    // console.log('CondicionalForm.this.state: ', this.state);

    return (
      <Modal
        title={venc_idf ? "Edição de Condicional" : "Inclusão de Condicional"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={'clientes'}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <VendaItemForm
          visivel={modalProdutoVisible}
          onSalvarProdutoClick={this.onSalvarProdutoClick}
          onFecharModalProdutoClick={this.onFecharModalProdutoClick}
          // listaProdutos={listaProdutos}
          produtoSelecionado={produtoSelecionado}
        />

        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados Principais" key="dados">
              <div style={{ height: 350 }}>
                <Form>
                  <Row>
                    <div className="div-subTitulo">
                      <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17 }}>
                        Dados da Condicional
                      </span>
                    </div>

                    <Col xs={24} sm={6} className="camposEspacoDireita">
                      <span>Numero</span>
                      <InputForm
                        id="venc_numero"
                        ref="venc_numero"
                        maxLength={9}
                        onChange={this.onChange}
                        value={venc_numero}
                        readOnly
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: 4 }} className="camposEspacoDireita">
                      <span>Data Emissão *</span>
                      <DatePicker
                        onChange={this.onDateChange}
                        format="DD/MM/YYYY"
                        showToday={true}
                        allowClear={false}
                        value={moment(venc_dt_venda, "DD/MM/YYYY", true)}
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col xs={24} sm={11}>
                      <PessoaFrame
                        label="Cliente *"
                        id="venc_pessoa"
                        value={venc_pessoa}
                        tipo="C"
                        width={"100%"}
                        onChange={this.onChangePessoa}
                        // disabled={caixaFechado}
                        descricaoPrimeiroItem="Selecione um Cliente"
                      />
                    </Col>
                    <Col xs={24} sm={1} style={{ marginTop: 24 }}>
                      <Tooltip title="Cadastro de Clientes" placement="topLeft">
                        <Button
                          type="dashed"
                          icon="plus"
                          htmlType="button"
                          onClick={() => this.onCadPessoaClick()}
                        />
                      </Tooltip>
                    </Col>
                    <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
                      <UsuarioFrame
                        label="Vendedor *"
                        id="venc_usuario"
                        value={venc_usuario}
                        width={"100%"}
                        vendedor={1}
                        onChange={this.onChangeVendedor}
                        descricaoPrimeiroItem="Selecione um Vendedor"
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                      <span>Quantidade Pordutos</span>
                      <InputForm
                        type="number"
                        id="venc_qtde_itens"
                        ref="venc_qtde_itens"
                        value={venc_qtde_itens}
                        decimalScale={0}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                      <span>Valor Total</span>
                      <InputForm
                        type="number"
                        id="venc_vlr_total"
                        ref="venc_vlr_total"
                        value={venc_vlr_total}
                        onChange={this.onChange}
                        disabled={true}
                      />
                    </Col>
                    <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                      <span>OBS</span>
                      <InputForm
                        id="venc_obs"
                        ref="venc_obs"
                        value={venc_obs}
                        maxLength={200}
                        onChange={this.onChange}
                        validator={value => Boolean(value)}
                      />
                    </Col>
                  </Row>

                </Form>
              </div>
            </TabPane>


            <TabPane tab="Lista dos Produtos" key="produtos">
              <div style={{ height: 350 }}>
                <Row>
                  <Col xs={24} style={{ marginTop: -60 }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.onNovoProduto}
                      icon="plus"
                      className="btn-primary"
                    > Novo Produto
                    </Button>
                  </Col>
                </Row>
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaProdutos}
                  rowKey={(listaProdutos => listaProdutos.mi_item + '_' + listaProdutos.mi_item_tamanho + '_' + listaProdutos.mi_item_cor)}
                >
                  <Column
                    key="prod_codigo"
                    dataIndex="prod_codigo"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="prod_descricao"
                    dataIndex="prod_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                    render={this.renderDescrProduto}
                  />
                  <Column
                    key="mi_qtde"
                    dataIndex="mi_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_unit"
                    dataIndex="mi_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_desc"
                    dataIndex="mi_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="mi_vlr_total"
                    dataIndex="mi_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  {this.state.visualizar ? null : (
                    <Column
                      key="acoes"
                      title=""
                      render={this.renderAcoesProdutos}
                      width={70}
                      align="center"
                      className="listaCadastro"
                    />
                  )}
                </Table>
              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar Condicional
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CondicionalForm.js